import { CollapseData } from './interfaces/collapse-data.interface';
import { DataTable, Sort } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-datatable-table',
  templateUrl: './datatable-table.component.html',
  styleUrls: ['./datatable-table.component.scss']
})
export class DatatableTableComponent implements OnInit, OnChanges {

  @Input() id: string;
  @Input() datatable: DataTable;
  @Input() loading: boolean;
  @Input() data: any[];
  @Input() sorts: Sort[] = [];

  @Output() onSortCambiados = new EventEmitter<Sort[]>();

  collapseData: CollapseData[] = [];

  ngOnInit(): void {
    this.setCollapseData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.setCollapseData();
    }
  }

  setCollapseData() {
    if (this.datatable.collapsing) {
      this.collapseData = this.data ? this.data.map(item => { return { 
        open: false,
        canCollapse: this.datatable.collapsing.collapse && this.datatable.collapsing.collapse(item)
      } }) : [];
      this.datatable.hooks.onCollapseData(this.collapseData);
    }
  }

  toggleCollapseData(index) {
    if (this.collapseData[index].canCollapse) {
      this.collapseData[index].open = !this.collapseData[index].open;
      this.datatable.hooks.onCollapseData(this.collapseData);
    }
  }

  colspan() {
    return this.datatable.columnas.filter(x => x.mostrar !== false).length +
           (this.datatable.collapsing ? 1 : 0);
  }

  sortCambiados(sorts: Sort[]) {
    this.sorts = sorts;
    this.onSortCambiados.emit(this.sorts);
  }

}
